import script from "./index5.vue?vue&type=script&setup=true&lang=js"
export * from "./index5.vue?vue&type=script&setup=true&lang=js"

import "./index5.vue?vue&type=style&index=0&id=2ffdf698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffdf698"]])

export default __exports__